import { CheckboxInput } from '@framework/form/inputs/CheckboxInput.tsx';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem.tsx';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { ParagraphSizeText } from '../../common/style/ParagraphSizeText.tsx';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { type ComputedWidget } from '../IComputedWidget.ts';

export interface IComputedBooleanWidgetPreviewProps
  extends IWidgetComponentProps<ComputedWidget> {}

export function ComputedBooleanWidgetPreview(
  props: IComputedBooleanWidgetPreviewProps,
) {
  const { componentLayout } = props;
  const options = getWidgetProps(props);

  return (
    <ConfigFormItem
      name="string"
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={
        options?.helpText ? (
          <RichTextAdvancedRender inline text={options?.helpText} />
        ) : undefined
      }
      layout={{ hideVisualLabel: options?.hideLabel }}
      readonly={options.readonly}
      widget={props.widget}
    >
      <CheckboxInput name="string">
        <ParagraphSizeText>
          <RichTextAdvancedRender hasCustomFont inline text={options.text} />
        </ParagraphSizeText>
      </CheckboxInput>
    </ConfigFormItem>
  );
}
